import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenName',
    standalone: true,
})
export class ShortenNamePipe implements PipeTransform {
    transform(value: string): string {
        if (value.length > 5 ) {
            return value.substring(0, 4) + '\u2026';
        }
        return value;
    }
}
